import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SetupPortalPage from '../../components/setup/SetupPortalPage';
import WorkflowForm from '../../components/workflows/WorkflowForm';
import api from '../../API.js';
import styles from '../../styles/workflows.module.css';
import { AGENT_SETUP_BASE } from '../../constants/setupRoadmapSteps';

function WorkflowCreate() {
    const navigate = useNavigate();

    const handleCreate = async (formData) => {
        try {
            const response = await api.post('workflow', { body: formData });
            
            if (response.status !== 200) {
                let errorMessage = `HTTP error! status: ${response.status}`;
                if (response.data) {
                    if (typeof response.data === 'string') {
                        errorMessage = response.data;
                    } else if (response.data.message) {
                        errorMessage = response.data.message;
                    } else if (response.data.error) {
                        errorMessage = response.data.error;
                    }
                }
                throw new Error(errorMessage);
            }

            navigate(`${AGENT_SETUP_BASE}/workflows`);
        } catch (err) {
            throw err;
        }
    };

    return (
        <SetupPortalPage>
            <div className={styles.container}>
                <div style={{ marginBottom: '2em' }}>
                    <Link
                        to={`${AGENT_SETUP_BASE}/workflows`}
                        style={{
                            color: '#007bff',
                            textDecoration: 'none',
                            fontSize: '14px',
                        }}
                    >
                        ← Back to Workflows
                    </Link>
                </div>

                <h1>Create New Workflow</h1>

                <WorkflowForm
                    workflow={null}
                    onSubmit={handleCreate}
                    onCancel={() => navigate(`${AGENT_SETUP_BASE}/workflows`)}
                />
            </div>
        </SetupPortalPage>
    );
}

export default WorkflowCreate;
